var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Popup',{attrs:{"show":_vm.openModal},on:{"close":_vm.close},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('div',{staticClass:"mb-xs"},[_c('h1',[_vm._v("Error Message")])])]},proxy:true}])},[_c('div',[_vm._v(" "+_vm._s(_vm.message)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }